<template>
    <div class="content-wrapper">
        <modals-container @confirm="confirmDelete"></modals-container>
        <div class="page-heading">
            <div class="page-content fade-in-up">
                <div class="row">
                    <div class="col-md-12">
                        <div class="ibox">
                            <div class="ibox-body">
                                <ul class="nav nav-tabs tabs-line">
                                    <li class="nav-item">
                                        <a @click="clearUpdateCompany" id="companiesList" class="nav-link active"
                                           href="#tab-1" data-toggle="tab">{{$t('message.listOfCompanies')}}</a>
                                    </li>
                                    <li v-if="!updateCompany" class="nav-item">
                                        <a class="nav-link" href="#tab-2" data-toggle="tab">{{$t('message.addNewCompany')}}</a>
                                    </li>
                                    <li v-if="updateCompany" class="nav-item">
                                        <a id="updateCompanyTab" class="nav-link" href="#tab-2"
                                           data-toggle="tab">{{$t('message.updateCompany')}}</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div id="tab-1" class="tab-pane fade active show">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <!-- <div class="input-group-icon right">
                                                                <div class="input-icon"><i class="fa fa-search"></i>
                                                                </div>
                                                                <input v-model="contactsFilter" @keyup="filterContacts"
                                                                       class="form-control" type="text"
                                                                       :placeholder="$t('message.filterContacts')">
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <table class="table table-striped">
                                                            <thead>
                                                            <tr>
                                                                <th scope="col"></th>
                                                                <th scope="col">{{$t('message.companyName')}}</th>
                                                                <th scope="col">{{$t('message.companyWebsite')}}</th>
                                                                <th scope="col">{{$t('message.companyAbbreviation')}}</th>
                                                                <!-- <th scope="col">{{$t('message.listOfBkp')}}</th> -->
                                                                <th scope="col"></th>
                                                            </tr>
                                                            </thead>
                                                            <tbody v-if="companies.length !== 0">
                                                            <tr v-for="(company, index) in companies" :key="index">
                                                                <th scope="row">{{index + 1}}</th>
                                                                <td scope="col">{{company.name}}</td>
                                                                <td scope="col">{{company.website}}</td>
                                                                <td scope="col">{{company.abbreviation}}</td>
                                                                <td scope="col">
                                                                    <!-- <ul style="list-style-type:none;">
                                                                    <li v-for="(job, index) in user.jobs" :key="index">
                                                                      {{ job.name }}
                                                                    </li>
                                                                  </ul> -->

                                                                </td>
                                                                <td class="text-right">
                                                                    <a href="#tab-2" @click="setUpdateCompany(company)"
                                                                       data-toggle="tab"
                                                                       data-original-title="Edit"
                                                                       class="btn btn-default btn-xs m-r-5"><i
                                                                            class="fa fa-pencil font-8"></i>
                                                                    </a>
                                                                    <button @click="deleteCompany(company)"
                                                                            data-toggle="tooltip"
                                                                            data-original-title="Delete"
                                                                            class="btn btn-default btn-xs"><i
                                                                            data-v-2fbef3e4=""
                                                                            class="fa fa-trash font-8"></i></button>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="tab-2" class="tab-pane fade active-show">
                                        <div class="page-heading">
                                            <div class="page-content fade-in-up">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="ibox">
                                                            <div class="ibox-body">
                                                                <div class="tab-content">
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <div class="row">
                                                                                <div class="col-md-4">
                                                                                    <div class="form-group">
                                                                                        <label>{{$t('message.companyName')}}</label>
                                                                                        <input v-model="company.name"
                                                                                               type="text"
                                                                                               class="form-control"
                                                                                               :placeholder="$t('message.companyName')">
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-4">
                                                                                    <div class="form-group">
                                                                                        <label>{{$t('message.companyAbbreviation')}}</label>
                                                                                        <input v-model="company.abbreviation"
                                                                                               type="text"
                                                                                               class="form-control"
                                                                                               :placeholder="$t('message.companyAbbreviation')">
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-4">
                                                                                    <div class="form-group">
                                                                                        <label>{{$t('message.companyWebsite')}}</label>
                                                                                        <input v-model="company.website"
                                                                                               type="text"
                                                                                               class="form-control"
                                                                                               :placeholder="$t('message.companyWebsite')">
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <!-- Company name and website -->
                                                                            <div class="row">
                                                                                
                                                                                
                                                                                <div class="col-md-2">
                                                                                  
                                                                                </div>
                                                                            </div>
                                                                            <!--Address data-->
                                                                            <div class="row">
                                                                                <div class="col-md-3">
                                                                                    <div class="form-group">
                                                                                        <label>{{$t('message.city')}}</label>
                                                                                        <input v-model="company.city"
                                                                                               type="text"
                                                                                               class="form-control"
                                                                                               :placeholder="$t('message.city')">
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-3">
                                                                                   
                                                                                     <div class="form-group">
                                                                                        <label>{{$t('message.zipCode')}}</label>
                                                                                        <input v-model="company.zip_code"
                                                                                               type="text"
                                                                                               class="form-control"
                                                                                               :placeholder="$t('message.zipCode')">
                                                                                    </div>
                                                                                </div>
                                                                            
                                                                            
                                                                                <div class="col-md-3">
                                                                                    <div class="form-group">
                                                                                        <label>{{$t('message.street')}}</label>
                                                                                        <input v-model="company.street"
                                                                                               type="text"
                                                                                               class="form-control"
                                                                                               :placeholder="$t('message.street')">
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-3">
                                                                                      <div class="form-group">
                                                                                        <label>{{$t('message.streetNr')}}</label>
                                                                                        <input v-model="company.street_number"
                                                                                               type="text"
                                                                                               class="form-control"
                                                                                               :placeholder="$t('message.streetNr')">
                                                                                    </div>
                                                                                </div>
                                                                               
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr>
                                                    
                                                                    <div class="row">
                                                                        <div class="col-md-12 text-center">
                                                                             <button v-if="!updateCompany"
                                                                                    @click="addNewCompany"
                                                                                    style="margin: 1%;"
                                                                                    class="btn btn-primary">
                                                                                {{$t('message.add')}}
                                                                            </button>
                                                                            
                                                                            <button v-if="updateCompany"
                                                                                    @click="confirmUpdateCompany"
                                                                                    style="margin: 1%"
                                                                                    class="btn btn-primary">
                                                                                {{$t('message.update')}}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import OkModal            from '../../modals/OkModal'
  import DialogModal        from '../../modals/DialogModal'
 

  export default {
    name: 'Contacts',
    data () {
      return {
        showMultiSelect: false,
        showAddEditPhones: true,
        updateCompany: false,
        contactsFilter: '',
        companies: [],
        usersFiltered: [],
        jobs: [],
        users: [],
        user: null,
        userType: false,
        defaultUser: {
          jobs: [],
          phones: [],
          first_name: '',
          last_name: '',
          email: '',
          zip_code: '',
          street: '',
          street_number: '',
          city: '',
          state: '',
          country: '',
          company_name: '',
          company_website: '',
          is_craftsmen: true,
          is_manager: false,
          preferred_language: 'en'
        },
        company: {
            name: '',
            website: '',
            zip_code: '',
            street: '',
            street_number: '',
            city: '',
            state: '',
            country: '',
        }
      }
    },
    created () {
      
      this.getCompaniesList()
      // get jobs
    //   this.getList(this.apiPrefix, this.jobApiUrl).then(resp => {
    //     this.jobs = resp.data
    //     this.showMultiSelect = true
    //   }).catch(err => {
    //     console.log(err.response)
    //   })
    },
    methods: {
      getCompaniesList(){
          // get companies
        this.getList(this.apiPrefix, this.companyApiUrl).then(resp => {
            this.companies = resp.data
        }).catch(err => {
            console.log(err)
        })
      },
    //   filterContacts () {
    //     let filter = this.contactsFilter.toLowerCase()

    //     this.usersFiltered = this.users.filter(user => {
    //       if (filter === '') {
    //         return true
    //       }

    //       return (user.first_name ? user.first_name.toLowerCase().startsWith(filter) : '')
    //         || (user.last_name ? user.last_name.toLowerCase().startsWith(filter) : '')
    //         || (user.company_name ? user.company_name.toLowerCase().startsWith(filter) : '')
    //     })
    //   },
    confirmUpdateCompany () {
        let self = this
       
        this.update(this.apiPrefix, this.companyApiUrl + '/', this.company.id, this.company)
          .then(() => {
            self.$modal.show(OkModal, {
                text: self.$t('message.companySuccessfullyUpdated'),
                modalClass: self.modalClasses.okSuccessClass
              },
              {
                width: self.modalWidth(),
                height: 'auto'
              })
          })
          .catch(err => {
            let msg = self.createErrorMessage(self.parseErrors(err.response.data.errors))

            self.$modal.show(OkModal, {
                text: msg,
                modalClass: self.modalClasses.okErrorClass
              },
              {
                width: self.modalWidth(),
                height: 'auto'
              })
          })
      },
      clearUpdateCompany () {
        this.updateCompany = false
        this.showMultiSelect = false
        // this.showAddEditPhones = false
        // this.user = JSON.parse(JSON.stringify(this.defaultUser))

        this.$nextTick(() => {
          // Add the component back in
          this.showMultiSelect = true
          this.showAddEditPhones = true
        })

        const tab2 = document.getElementById('tab-2')
        tab2.classList.remove('active')
      },
      setUpdateCompany (company) {

        this.showMultiSelect = false
        this.updateCompany = true
        this.company = company

        this.$nextTick(() => {
          // Add the component back in
          this.showMultiSelect = true
        })

        const companiesList = document.getElementById('companiesList')
        companiesList.classList.remove('active')

      },
      confirmDelete (companyId) {

        let self = this
        this.delete(this.apiPrefix, this.companyApiUrl + '/', companyId).then( () => {
           self.getCompaniesList()
        }).catch(err => {
          console.log(err.response)
        })
      },
      deleteCompany (company) {

        this.$modal.show(DialogModal, {
            text: `${this.$t('message.confirmDelete')} ${company.name}?`,
            param: company.id,
            event: 'confirm'
          },
          {
            width: this.modalWidth(),
            height: 'auto'
          })
      },
    //   selectType (type) {
    //     if (type === 'craftsman') {
    //       this.user.is_craftsmen = true
    //       this.user.is_manager = false
    //     } else {
    //       this.user.is_craftsmen = false
    //       this.user.is_manager = true
    //     }
    //   },
      addNewCompany () {
        let self = this
        this.post(this.apiPrefix, this.companyApiUrl + '/', '', this.company).then(resp => {
    
          self.$modal.show(OkModal, {
              text: self.$t('message.companySuccessfullyCreated'),
              modalClass: self.modalClasses.okSuccessClass
            },
            {
              width: self.modalWidth(),
              height: 'auto'
            })

          self.companies.push(resp.data['object'])
          // sort new data
          self.companies.sort((a, b) => {
            return a.name >= b.name ? 1 : -1
          })

          this.showMultiSelect = false
          this.company = {}
        //   this.showAddEditPhones = false
        //   self.user = JSON.parse(JSON.stringify(self.defaultUser))

          this.$nextTick(() => {
            // Add the component back in
            this.showMultiSelect = true
            //this.showAddEditPhones = true
          })

        }).catch(err => {
          let msg = self.createErrorMessage(self.parseErrors(err.response.data.errors))

          self.$modal.show(OkModal, {
              text: msg,
              modalClass: self.modalClasses.okErrorClass
            },
            {
              width: self.modalWidth(),
              height: 'auto'
            })
        })
      },
    //   jobRemoved (obj) {
    //     let index = this.user.jobs.indexOf(obj)
    //     this.user.jobs.splice(index, 1)
    //   },
    //   chosenJob (obj) {
    //     this.user.jobs.push(obj)
    //   }
    },
    computed: {
    //   computedUserJobs () {
    //     return this.user.jobs
    //   }
    }
  }
</script>

<style scoped>
    label {
        font-weight: bold;
        width: 190px;
    }

    select{
      width: 50px;
    }
</style>